import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../../../reducers/types";
import { CfarCancellationPolicy } from "./component";
import {
  hotelCfarQuoteFromChosenRoomProductSelector,
  hotelCfarQuoteFromChosenRoomProductV2Selector,
} from "../../../../../shop/reducer";
import { isHotelCfarLanguageEnabledSelector } from "../../../../reducer";
import {
  getFromDateInBook,
  getHotelBookSelectedAvailability,
} from "../../../../../book/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hotelCfarQuote: hotelCfarQuoteFromChosenRoomProductSelector(state),
  hotelCfarQuoteV2: hotelCfarQuoteFromChosenRoomProductV2Selector(state),
  checkInDate: getFromDateInBook(state),
  checkInTime:
    getHotelBookSelectedAvailability(state)?.lodging.checkInInstructions
      ?.checkInTime,
  isHotelCfarLanguageEnabled: isHotelCfarLanguageEnabledSelector(state),
});
const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CfarCancellationPolicyConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCfarCancellationPolicy = withRouter(
  connector(CfarCancellationPolicy)
);
